import React, { useMemo } from 'react'
import { itemsCounter } from '../../settings/home-page-settings'
import { LabeledSelect } from '../../shared/labeled-select'

export type ShowItemsSelectProps = {
  value: number
  onChange: (pageSize: number) => void
  disabled?: boolean
  label: string
  idSuffix?: string
  className?: string
}

export const ShowItemsSelect: React.FC<ShowItemsSelectProps> = ({
  value,
  onChange,
  disabled = false,
  label,
  idSuffix = '',
  className,
}) => {
  const options = useMemo(
    () => itemsCounter.map((n) => ({ value: n, label: String(n) })),
    []
  )

  return (
    <LabeledSelect
      label={label}
      value={value}
      options={options}
      onChange={onChange}
      disabled={disabled}
      idSuffix={idSuffix ? `show-items-${idSuffix}` : 'show-items'}
      className={className}
      fluid
    />
  )
}
